import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';
@Component({
  selector: 'app-interests',
  templateUrl: './interests.component.html',
  styleUrls: ['./interests.component.scss']
})
export class InterestsComponent implements OnInit {
  activeTab: 'received' | 'sent' | 'accepted' | 'rejected' = 'received';
  acceptedSubTab: 'byMe' | 'me' = 'byMe';
  rejectedSubTab: 'byMe' | 'me' = 'byMe';

  receivedInterests: any[] = [];
  sentInterests: any[] = [];
  acceptedByMeInterests: any[] = [];
  acceptedMeInterests: any[] = [];
  rejectedByMeInterests: any[] = [];
  rejectedMeInterests: any[] = [];

  loading = false;
  base64Images: { [profileId: string]: string } = {};

  constructor(private apiService: ApiServiceService, private router: Router, private route: ActivatedRoute, private location: Location) {}

  ngOnInit(): void {
    if (!this.isLoggedIn) {
      this.router.navigate(['/login']);
      return;
    }
    this.route.queryParams.subscribe(params => {
      if (params['tab'] === 'accepted') this.activeTab = 'accepted';
      else if (params['tab'] === 'sent') this.activeTab = 'sent';
      else if (params['tab'] === 'rejected') this.activeTab = 'rejected';
      else this.activeTab = 'received';
    });
    this.loadAll();
    this.markAsRead();
  }
  goBack(): void {
  this.location.back();
}

  markAsRead(): void {
    if (this.sessionToken && this.profileId) {
      this.apiService.markInterestsRead(this.sessionToken, this.profileId).subscribe({
        next: () => console.log('Interests marked as read'),
        error: (err) => console.error('Failed to mark interests as read', err)
      });
    }
  }

  get isLoggedIn(): boolean {
    return !!localStorage.getItem('sessionToken');
  }

  get profileId(): string | null {
    return localStorage.getItem('profileId');
  }

  get sessionToken(): string | null {
    return localStorage.getItem('sessionToken');
  }

  loadAll(): void {
    if (!this.sessionToken || !this.profileId) return;
    this.loading = true;

    forkJoin({
      received: this.apiService.getReceivedInterests(this.sessionToken, this.profileId),
      sent: this.apiService.getSentInterests(this.sessionToken, this.profileId)
    }).subscribe(
      res => {
        this.loading = false;
        
        let allAccepted: any[] = [];

        // 1. Process Received Pending & Rejected By Me
        if (res.received.status === 'success' && Array.isArray(res.received.data)) {
          this.receivedInterests = res.received.data
            .filter((i: any) => i.interest_status === 'Pending')
            .map((i: any) => this.normalizeInterest(i, 'received'));
            
          this.rejectedByMeInterests = res.received.data
            .filter((i: any) => i.interest_status === 'Declined')
            .map((i: any) => this.normalizeInterest(i, 'rejectedByMe'));

          allAccepted = allAccepted.concat(res.received.data.filter((i: any) => i.interest_status === 'Accepted'));
        }

        // 2. Process Sent Pending & Rejected Me
        if (res.sent.status === 'success' && Array.isArray(res.sent.data)) {
          this.sentInterests = res.sent.data
            .filter((i: any) => i.interest_status === 'Pending')
            .map((i: any) => this.normalizeInterest(i, 'sent'));
            
          this.rejectedMeInterests = res.sent.data
            .filter((i: any) => i.interest_status === 'Declined')
            .map((i: any) => this.normalizeInterest(i, 'rejectedMe'));

          allAccepted = allAccepted.concat(res.sent.data.filter((i: any) => i.interest_status === 'Accepted'));
        }

        // 3. Process Accepted (Global Deduplication)
        this.acceptedByMeInterests = [];
        this.acceptedMeInterests = [];
        
        // Sort by _id ascending so the original request record (created first) takes precedence over duplicate reverse records
        allAccepted.sort((a, b) => {
          if (!a._id || !b._id) return 0;
          return a._id.toString().localeCompare(b._id.toString());
        });

        const seenProfileIds = new Set();
        
        for (const i of allAccepted) {
          const receiverId = typeof i.selected_profile_id === 'object' ? i.selected_profile_id?._id : i.selected_profile_id;
          const senderId = typeof i.interest_owner_id === 'object' ? i.interest_owner_id?._id : i.interest_owner_id;
          
          console.log('[Accepted Validation]', { interestId: i._id, sender: senderId, receiver: receiverId, currentProfile: this.profileId, status: i.interest_status });

          if (receiverId === this.profileId) {
            const mapped = this.normalizeInterest(i, 'acceptedByMe');
            if (!seenProfileIds.has(mapped._profileId)) {
              seenProfileIds.add(mapped._profileId);
              this.acceptedByMeInterests.push(mapped);
            }
          } else if (senderId === this.profileId) {
            const mapped = this.normalizeInterest(i, 'acceptedMe');
            if (!seenProfileIds.has(mapped._profileId)) {
              seenProfileIds.add(mapped._profileId);
              this.acceptedMeInterests.push(mapped);
            }
          }
        }
      },
      err => {
        this.loading = false;
        console.error('Error loading interests:', err);
      }
    );
  }

  loadReceivedInterests(): void {
    // Deprecated in favor of forkJoin in loadAll
  }

  loadSentInterests(): void {
    // Deprecated in favor of forkJoin in loadAll
  }

  mergeAccepted(): void {
    // Deprecated
  }

  deduplicateProfiles(arr: any[]): any[] {
    const seen = new Set();
    return arr.filter(item => {
      if (seen.has(item._profileId)) return false;
      seen.add(item._profileId);
      return true;
    });
  }

  normalizeInterest(item: any, direction: 'received' | 'sent' | 'acceptedByMe' | 'acceptedMe' | 'rejectedByMe' | 'rejectedMe'): any {
    // For received, acceptedByMe, rejectedByMe: populated profile is 'interest_owner_id'
    // For sent, acceptedMe, rejectedMe: populated profile is 'selected_profile_id'
    const profileData = (direction === 'sent' || direction === 'acceptedMe' || direction === 'rejectedMe')
      ? (item.selected_profile_id || {})
      : (item.interest_owner_id || {});

    const profileId = typeof profileData === 'object' ? profileData._id : profileData;
    const basic = profileData.basic_info || {};
    const personal = profileData.personal_info || {};
    const residing = profileData.residing_location || {};

    // Load photo
    if (profileId && !this.base64Images[profileId]) {
      this.loadImage(profileData, profileId);
    }

    return {
      ...item,
      _profileId: profileId,
      _name: `${basic.first_name || ''} ${basic.last_name || ''}`.trim() || 'Member',
      _age: this.calcAge(basic.date_of_birth),
      _location: this.extractLocation(residing),
      _direction: direction,
      _isVerified: !!profileData.verify?.id_proof_verify_status
    };
  }

  calcAge(dob: string): number | string {
    if (!dob) return '--';
    const today = new Date();
    const birth = new Date(dob);
    let age = today.getFullYear() - birth.getFullYear();
    if (today.getMonth() < birth.getMonth() ||
        (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  }

  extractLocation(loc: any): string {
    const city = loc?.city_id?.city_nme || '';
    const state = loc?.state_id?.name_1 || loc?.state_id?.state_nme || '';
    if (city && state) return `${city}, ${state}`;
    return city || state || 'Not specified';
  }

  loadImage(profileData: any, profileId: string): void {
    const basic = profileData.basic_info || {};
    const personal = profileData.personal_info || {};
    const idKey = basic.keycloak_id || basic.ory_identity_id || profileId;
    const avatarId = personal.avatar_Id;
    if (idKey && avatarId) {
      const imgUrl = `${idKey}/gallery/avatar/${avatarId}`;
      this.apiService.getImageBase64(imgUrl).subscribe(
        data => { if (data?.base64Image) this.base64Images[profileId] = data.base64Image; },
        err => console.error('Image load error', err)
      );
    }
  }

  acceptInterest(interest: any): void {
    if (!this.sessionToken || !this.profileId) return;
    const originalSenderId = interest._profileId;
    const originalReceiverId = this.profileId;
    if (!originalSenderId) return;

    this.apiService.setConnectionStatus(this.sessionToken, originalSenderId, originalReceiverId, 'Accepted').subscribe(
      () => {
        interest.interest_status = 'Accepted';
        interest._direction = 'acceptedByMe';
        // Move from received to acceptedByMe
        this.receivedInterests = this.receivedInterests.filter(i => i !== interest);
        this.acceptedByMeInterests.unshift({ ...interest, _direction: 'acceptedByMe' });
        Swal.fire({
          icon: 'success',
          title: 'Interest Accepted!',
          text: 'You are now connected. You can start chatting.',
          confirmButtonColor: '#8c002a'
        });
      },
      err => {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Could not accept interest. Please try again.' });
      }
    );
  }

  rejectInterest(interest: any): void {
    if (!this.sessionToken || !this.profileId) return;
    const originalSenderId = interest._profileId;
    const originalReceiverId = this.profileId;
    if (!originalSenderId) return;

    Swal.fire({
      title: 'Decline Interest?',
      text: 'Are you sure you want to decline this interest?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#8c002a',
      confirmButtonText: 'Yes, Decline'
    }).then(result => {
      if (!result.isConfirmed) return;
      this.apiService.setConnectionStatus(this.sessionToken!, originalSenderId, originalReceiverId, 'Declined').subscribe(
        () => {
          this.receivedInterests = this.receivedInterests.filter(i => i !== interest);
          Swal.fire({ icon: 'info', title: 'Declined', text: 'The interest has been declined.', confirmButtonColor: '#8c002a' });
        },
        err => Swal.fire({ icon: 'error', title: 'Error', text: 'Could not decline. Please try again.' })
      );
    });
  }

  cancelSentInterest(interest: any): void {
    if (!this.sessionToken || !this.profileId) return;
    const targetProfileId = interest._profileId;
    if (!targetProfileId) return;

    Swal.fire({
      title: 'Revert Request?',
      text: `Are you sure you want to cancel the interest request sent to ${interest._name || 'this profile'}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#800020',
      confirmButtonText: 'Yes, Cancel Request'
    }).then((result) => {
      if (!result.isConfirmed) return;
      this.apiService.setConnectionStatus(this.sessionToken!, this.profileId, targetProfileId, 'Cancelled').subscribe(
        () => {
          this.sentInterests = this.sentInterests.filter(i => i !== interest);
          Swal.fire({
            title: 'Cancelled',
            text: 'Your interest request has been reverted.',
            icon: 'success',
            confirmButtonColor: '#800020'
          });
        },
        err => {
          console.error('Error cancelling interest:', err);
          Swal.fire('Error', 'Could not cancel request. Please try again.', 'error');
        }
      );
    });
  }

  viewProfile(profileId: string): void {
    if (profileId) {
      this.router.navigate(['/profile-details', profileId]);
    }
  }

  get totalAccepted(): number {
    return this.acceptedByMeInterests.length + this.acceptedMeInterests.length;
  }

  get totalRejected(): number {
    return this.rejectedByMeInterests.length + this.rejectedMeInterests.length;
  }

  setTab(tab: 'received' | 'sent' | 'accepted' | 'rejected'): void {
    this.activeTab = tab;
  }
}
